// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"q5-z"};